export const requestSignInOtp = {
  title: 'Acessar usando e-mail',
  subtitle:
    'Informe seu e-mail para acessar a plataforma, em seguida confirme o código enviado.',
};
